<tilby-dialog-toolbar (confirm)="confirm()" [disabled]="!selectedCombination" [title]="item.name"/>

<tilby-dialog-content class="tw-flex tw-flex-col">
    <div class="tw-w-full tw-py-2" style="border-bottom: 1px solid lightgrey;">
        <div class="tw-flex tw-justify-between">
            <div class="tw-text-left tw-pl-[76px]">Nome</div>
            <div class="tw-text-right tw-pr-1">{{'CASHREGISTER.SELECT_SALE_COMBINATION.PRICE_1' | translate}}</div>
        </div>
    </div>
    <mat-radio-group class="tw-h-full tw-flex tw-flex-col" [(ngModel)]="selectedCombination">
        @for(comb of combinations; track comb){
            <mat-radio-button class="tw-pr-3" [value]="comb.combinationRef">
                <div class="tw-w-full tw-flex">
                    <div class="stock-status tw-w-6 tw-mr-2 tw-ml-0 tw-rounded-full" [ngClass]="getCombinationStockAvailability(comb)"></div>
                    <div class="tw-justify-between tw-w-full tw-flex">
                        <div class="tw-flex">{{ comb.name }}</div>
                        @if(showPrices){
                            <div>{{ comb.price | tilbyCurrency }}</div>
                        } @else {
                            <div>***</div>
                        }
                    </div>
                </div>
            </mat-radio-button>
        }
    </mat-radio-group>
</tilby-dialog-content>


